import React, { useState } from "react";
import CTA from "./CTA";
import AnimationContainer from "./animationContainer";

function Scholarship({ name, description, link, img, id }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex flex-col items-center mb-8 text-center md:w-[700px]">
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2"
      >
        <p className="text-xl sm:text-3xl">{name}</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={`size-4 sm:size-6 transtion-all duration-500 ${
            open ? "rotate-90" : ""
          }`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m8.25 4.5 7.5 7.5-7.5 7.5"
          />
        </svg>
      </button>
      {open && (
        <AnimationContainer animation="fade-in" classes="w-full mb-6">
          <div className="text-center">
            <img src={img} className="w-[150px] md:w-[300px] mx-auto mt-6 rounded-sm" alt={`image of ${name}`} />
            <p className="p-8 text-sm">{description}</p>
            <div className="w-full text-center mb-4 flex justify-center">
              <a
                href={link}
                target="_blank"
                rel="noreferrer"
                className="uppercase w-max py-4 px-16 text-sm bg-transparent border border-black text-black hover:text-white hover:bg-black transition-colors duration-500"
                aria-label={`Learn More about the ${name}`}
              >
                Learn more
              </a>
            </div>
          </div>
        </AnimationContainer>
      )}
    </div>
  );
}

export default Scholarship;
